"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentLocationButton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CurrentLocationButton = () => {
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    open: tooltipOpen,
    onClose: onTooltipClose,
    onOpen: onTooltipOpen
  } = (0, _presentationHooks.useDisclose)();
  const {
    mapLocation: {
      currentLocation,
      isCurrentLocationButtonVisible,
      locatePositionInMap
    }
  } = (0, _contexts.useMap)();
  const onClick = (0, _react.useCallback)(() => {
    locatePositionInMap(currentLocation, _models.MapLocationType.CurrentButton);
  }, [currentLocation, locatePositionInMap]);
  const onTooltipToggle = (0, _react.useCallback)(() => {
    if (!isCurrentLocationButtonVisible) {
      if (tooltipOpen) {
        onTooltipClose();
      } else {
        onTooltipOpen();
        setTimeout(() => {
          onTooltipClose();
        }, 5000);
      }
    }
  }, [isCurrentLocationButtonVisible, onTooltipClose, onTooltipOpen, tooltipOpen]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Tooltip, {
    open: tooltipOpen,
    title: isCurrentLocationButtonVisible ? null : translations.locationDisabledTooltip,
    placement: "left",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "button",
      tabIndex: 0,
      onKeyDown: onTooltipToggle,
      onClick: onTooltipToggle,
      onMouseEnter: onTooltipOpen,
      onMouseLeave: onTooltipClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        "data-testid": getTestId(_models.TestId.SelectPickupPointDialogCurrentLocationButton),
        color: "default",
        size: "large",
        variant: "contained",
        disabled: !isCurrentLocationButtonVisible,
        onClick: onClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.MapSelector, {})
      })
    })
  });
};
exports.CurrentLocationButton = CurrentLocationButton;